import { ReferToneDto, ReferToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/refertone/refertonedto';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { APIFeatures } from 'src/com/sixdee/crbtportal/core/util/apifeatures';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import {UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState } from '../../../toolkit/uicomponent';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { ToneOptionsType } from '../tonedetailspopup/tonedetailspopupcomponent';
import { NameTuneBuyCSSStyleImpl } from './nametunebuycss';
import { NameTuneBuyViewImpl } from './nametunebuyview';
import { BuyNameToneAPIModelImpl, BuyNameToneAPIModel } from './nametuneapimodel';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { GetPackDetails } from '../getpackdetails';
import { GetTonePriceDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/gettoneprice/gettonepricedetailsdto';

export interface NameTuneBuyComponentProps extends UIComponentProps
{
    toneOptionsType: ToneOptionsType;
    toneDto: ToneDto;
    closePopup(): void;
    showPopupOption(id:string):void;
    showPopup(id:string,msg:string,type:AlertType):void;

}

export interface NameTuneBuyComponentState extends UIComponentState{
    isPrice: boolean;
    price:string;
    packName: string;
    msisdn: string;
}
export interface NameTuneBuyComponentHandler extends UIComponentHandler
{
    onVerifyNumberClick(): void;
    onRequestOtpClick(): void;
}

export class NameTuneBuyComponent extends UIComponentImpl<NameTuneBuyComponentProps, NameTuneBuyComponentState, ReferToneDto> 
implements NameTuneBuyComponentHandler
{
    constructor(props: NameTuneBuyComponentProps)
    {
        super(props);
   
        this.state={price:this.getContext().getUserContext().getIsLoggedIn() ? '' : 
            this.getContext().getResources().getString(Strings.gift_default_value),
             packName: '', isPrice: false, msisdn: ""};
             
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<ReferToneDto>
    {
        return new NameTuneBuyViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new NameTuneBuyCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new BuyNameToneAPIModelImpl(applicationContext, apiModelHandler);
    }

    componentDidMount()
    {
        if(this.getContext().getUserContext().getIsLoggedIn())
        {
            (this.getView() as NameTuneBuyViewImpl).showLoader();   
            (this.getAPIModel() as BuyNameToneAPIModel).getTonePrice(this.props.toneDto.getId());
        }
    }

    onVerifyNumberClick(): void 
    {
        if(this.getContext().getUserContext().getIsLoggedIn())
        {
            (this.getView() as NameTuneBuyViewImpl).showLoader(); 
                let request = new ReferToneDtoImpl();
                request.setToneId(this.props.toneDto.getId());
                request.setToneName(this.props.toneDto.getToneName());
                request.setAPartyMsisdn(this.props.context.getUserContext().getMsisdn());
                request.setLanguage(this.props.context.getUserContext().getLanguage());
                request.setPackName(this.state.packName);
                (this.getAPIModel() as BuyNameToneAPIModel).buyTone(request);
        }
        else 
        {
            if(this.getView().validate())
            {
                (this.getView() as NameTuneBuyViewImpl).showLoader(); 
                (this.getAPIModel() as BuyNameToneAPIModel).getTonePriceNonLoggedInuser(
                    this.props.toneDto.getId(),(this.getView() as NameTuneBuyViewImpl).getData().getAPartyMsisdn());
            }
        }
    }
    onRequestOtpClick()
    {
          (this.getView() as NameTuneBuyViewImpl).showLoader();  
          (this.getAPIModel() as BuyNameToneAPIModel).getOTP((this.getView() as NameTuneBuyViewImpl).getOTPData());
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        if(feature === APIFeatures.GET_TONE_PRICE)
        {
            (this.getView() as NameTuneBuyViewImpl).dismissLoader();  

            let packDetails = this.props.context.getConfigurationSettings().getPropertyBasedOnLanguage("VALIDITY");
                
                console.log("packdetails: " + packDetails);
                
                let PRICE_TEXT: string = new GetPackDetails(packDetails)
                .getPrice((data as GetTonePriceDetailsDto).getPackName(),
                 (data as GetTonePriceDetailsDto).getPrice());
    
                 console.log("PRICE_TEXT: " + PRICE_TEXT +", packName: " + (data as GetTonePriceDetailsDto).getPackName());

             this.setState({price: PRICE_TEXT, msisdn: description, isPrice: true,
                packName: (data as GetTonePriceDetailsDto).getPackName()});
        }
        else if(feature === APIFeatures.ADD_NAMETUNE)
        {
            (this.getView() as NameTuneBuyViewImpl).dismissLoader(); 
            this.props.context.getUserContext().setPackName(this.state.packName);
            this.props.context.setUserContext(this.props.context.getUserContext());
            this.props.showPopup(this.getContext().getResources().getString(Strings.buy_nametune),this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),AlertType.SUCCESS);   
        }
        else  if(feature === APIFeatures.GENERATE_OTP)
        {
            (this.getView() as NameTuneBuyViewImpl).dismissLoader(); 
            (this.props.context.getUserContext().setMsisdnB(this.state.msisdn));
            (this.props.context.getUserContext().setSecToken(""));
            (this.props.context.getUserContext().setIsnewUser(false));
            (this.props.context.getUserContext().setPackName(this.state.packName));
            this.props.context.setUserContext(this.props.context.getUserContext());
           
           this.props.showPopupOption(this.getContext().getResources().getString(Strings.buy_nametune) + "_" +
           this.props.context.getResources().getString(Strings.otp_verification));
        }
        else
        {
            //  this.props.closePopup();   
            (this.getView() as NameTuneBuyViewImpl).dismissLoader(); 
        }
    }

   
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as NameTuneBuyViewImpl).dismissLoader(); 
        if(feature === APIFeatures.ADD_NAMETUNE)
        {
            this.props.showPopup(this.getContext().getResources().getString(Strings.buy_nametune),description,AlertType.ERROR);   

        }
        else if(feature === APIFeatures.GET_TONE_PRICE)
        {
            this.props.showPopup(this.props.context.getResources().getString(Strings.buy_now),description,AlertType.ERROR);

        }
        else
        {
            this.props.showPopup(this.getContext().getResources().getString(Strings.buy_now),description,AlertType.ERROR);   

        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/nametune/nametunebuycomponent.tsx